import React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionSummary, Box, Stack, Typography } from '@mui/material';

import { Accordion } from '../Accordion/Accordion';
import { Tab } from '../Tab';
import { Tabs } from '../Tabs';
import { ShuttleRouteTable } from './shuttle-route-table';
import { ShuttleProviders, getAvailableLocationsForProvider, getShuttleItinerary } from './type';

// ********************************************************************************
// Contains all available routes for a shuttle provider, its presented one
// location (tab) at a time.
type Props = {
  provider: ShuttleProviders;
  name: string;
  path: string;
  defaultExpanded?: boolean;
};
export const ShuttleProviderAccordion: React.FC<Props> = ({ provider, name, path, defaultExpanded }) => {
  const [selectedTab, setSelectedTab] = React.useState(0);
  const tabs = getAvailableLocationsForProvider(provider);

  // == Handlers ==================================================================
  const handleTabChange = (_: any, newValue: number) => {
    setSelectedTab(newValue);
  };

  // == Render ====================================================================
  return (
    <Accordion sx={{ boxShadow: 'none', border: '0' }} defaultExpanded={defaultExpanded}>
      <AccordionSummary
        sx={{ padding: { sm: '24px 16px', md: '24px' } }}
        expandIcon={
          <ExpandMoreIcon
            sx={{
              backgroundColor: 'primary.light',
              color: 'white',
              borderRadius: '50%',
              width: '32px',
              height: '32px',
            }}
          />
        }
      >
        <Stack gap="12px" width="100%" direction="row" alignItems="center" justifyContent="space-between">
          <Stack gap="16px" maxWidth={800} direction="row" alignItems="center">
            <Box>
              <img
                src={`/images/ShuttlePrice${path}.png`}
                style={{
                  width: 70,
                  height: 70,
                  backgroundSize: 'cover',
                }}
              />
            </Box>
            <Typography variant="h3" color="#3F2B56" fontFamily="Gotham-Medium" fontSize="24px" align="left">
              {name}
            </Typography>
          </Stack>
        </Stack>
      </AccordionSummary>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        aria-label="shuttle-location-tabs"
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs.map((location, index) => (
          <Tab
            key={location}
            label={location}
            sx={{
              fontSize: '16px',
              textTransform: 'uppercase',
              color: selectedTab === index ? 'primary.main' : 'text.primary',
              fontFamily: selectedTab === index ? 'Gotham-Bold' : 'Gotham-Book',
            }}
          />
        ))}
      </Tabs>
      <Box pt={2}>
        <ShuttleRouteTable routes={getShuttleItinerary(provider, tabs[selectedTab])} />
      </Box>
    </Accordion>
  );
};
